class Filter {
    constructor($el) {
        this.$el = $el;
        this.$filter = this.$el.find('[data-filter]');
        this.$items = this.$el.find('[data-category]');
        this.init();
    }

    init = () => {
        this.$filter.on('click', this.clickHandler);
    }

    clickHandler = (event) => {
        const $clickedProject = $(event.currentTarget);
        const value = $clickedProject.data('filter');
        this.$filter.removeClass("selected");
        $clickedProject.addClass("selected");
        

        this.$items.each((_, item) => {

            const $item = $(item);
            const categorieValue = $item.data('category');

            if (value === 'alle' || value === categorieValue) {
                $item.show();
            } else {
                $item.hide();
            }
        });
    }
}
export default Filter;
